import { css } from '@fable/theme'
import { Club } from '@fable/types'
import { PlanUpsell } from 'components/plan_selection'

export const ClubDetailPlanUpsellModal = ({ club }: { club: Club }) => (
  <div
    className={css`
      margin-top: -30px;
      overflow-y: scroll;
      height: calc(100vh - 50px);
    `}
  >
    <PlanUpsell small club={club} successActions={{ toast: true }} />
  </div>
)
